import { render } from "./Fornitori.vue?vue&type=template&id=ac54d9fe"
import script from "./Fornitori.vue?vue&type=script&lang=js"
export * from "./Fornitori.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__